import awesomegrid from './awesomegrid';
import borders from './borders';
import boxShadows from './boxShadows';
import breakpoints from './breakpoints';
import colors from './colors';
import font from './font';
import spacing from './space';

const brand = {
  awesomegrid,
  borders,
  boxShadows,
  breakpoints,
  colors,
  font,
  name: 'DEFAULT',
  spacing,
};

export default brand;
